import ListMap from '../core/ListMap';
import MetaAction from './MetaAction';

class MetaActionList extends ListMap {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super({
      ...args,
      data: data.map(v => new MetaAction({ ...args, data: { name: v }}))
    });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaAction({ data: { name: key } });
  }

  // merge(otherList) {
  //   return this._mergeWithReplace(otherList);
  // }
}

export default MetaActionList;
